/**
 * BarChain Client – Root app component.
 * Wiring: providers, router. No Firebase or business logic here.
 */
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../features/auth/AuthProvider';
import { UploadProvider } from '../features/upload/UploadContext';
import { AppRoutes } from './AppRoutes';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UploadProvider>
          <AppRoutes />
        </UploadProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
